import {putAll, takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {call, put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';
import {showBeError} from 'utils/show-be-error';

import {adminAction, GetRoleAction} from '../action';

function* execute({payload: {roleId}}: GetRoleAction): SagaIterator {
    const response = yield* call(Api.getRoleDetail, {roleId});

    if (response.isSuccess) {
        yield* put(adminAction.getRoleSuccess(response.data));
    } else {
        yield putAll(showBeError(response, t('admin')('loadRole')));
    }
}

/** Runs the admin saga that loads the selected role detail. */
export function* getRoleSaga(): SagaIterator {
    yield takeLatestF('admin/GET_ROLE', execute);
}
